import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { DeleteTemplateFieldsMutation, DeleteTemplateFieldsMutationVariables } from '@/graphql/generated/graphql';
import { DeleteTemplateFieldsDocument } from '@/graphql/generated/graphql';
export type DeleteTemplateFieldInput = {
  ItemId: string
  isHardDelete?: boolean
}

export type DeleteTemplateFieldResponse = {
  data: {
    deleteTemplateFields: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useDeleteTemplateField = () => {
  const mutation = useMutation({
    mutationKey: ['delete-template-field'],
    mutationFn: ({ ItemId, isHardDelete = false }: DeleteTemplateFieldInput) => {
      return graphqlClient.request<DeleteTemplateFieldsMutation>(DeleteTemplateFieldsDocument,
        { ItemId, isHardDelete }
      )
    }
  })

  return {
    ...mutation,
    deleteTemplateField: mutation.mutate,
    deleteTemplateFieldAsync: mutation.mutateAsync,
  }
}

export const DELETE_TEMPLATE_FIELD_MUTATION = DeleteTemplateFieldsDocument;
